import { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function useHistoryState(key, initialValue) {
  const navigate = useNavigate();
  const location = useLocation();

  const [rawState, rawSetState] = useState(() => {
    const value = location?.state?.[key];
    return value ?? initialValue;
  });

  function setState(value) {
    rawSetState(value);
    // replace the current state with the new state
    const currentPath = window.location.pathname;
    navigate(currentPath, {
      state: { ...location?.state, [key]: value },
      replace: true,
    });
  }
  return [rawState, setState];
}

export const adjustIntercomWidget = () => {
  const intercomWidgets = document.querySelectorAll('.intercom-launcher-frame, .intercom-launcher, .intercom-messenger-frame, .intercom-with-namespace-52k34s');
  intercomWidgets.forEach((widget) => {
    if (widget instanceof HTMLElement) {
      widget.style.right = '20px';
    }
  });
};
